module.exports = __webpack_public_path__ + "img/tablet-vitrine.f2e8ec00.webp";